import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

import useStorage from '../../../hooks/useStorage';
import useComponentMounted from '../../../hooks/useComponentMounted';
import { attachmentShape } from '../../../utils/attachments';
import AttachmentError from '../AttachmentError';

import { LoadingContainer } from './styles';

const GenericAttachment = ({
  attachment,
  AttachmentComponent,
}) => {
  const {
    getBlobUrl,
  } = useStorage();
  const [attachmentDownloadUrl, setAttachmentDownloadUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const getAttachmentLocalUrl = async () => {
      try {
        const downloadUrl = await getBlobUrl(attachment.assetPath);

        if (isComponentMountedRef.current) {
          setAttachmentDownloadUrl(downloadUrl);
          setIsLoading(false);
        }
      } catch (error) {
        if (isComponentMountedRef.current) {
          setShowError(true);
          setIsLoading(false);
        }
      }
    };
    getAttachmentLocalUrl();
  }, [
    attachment,
    getBlobUrl,
    isComponentMountedRef,
  ]);

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress name="crescent" />
      </LoadingContainer>
    );
  }

  return (
    showError
      ? <AttachmentError />
      : <AttachmentComponent attachmentData={attachment} assetLocalUrl={attachmentDownloadUrl} />
  );
};

GenericAttachment.propTypes = {
  attachment: attachmentShape,
  AttachmentComponent: PropTypes.any.isRequired,
};

GenericAttachment.defaultProps = {
  attachment: {},
};

export default GenericAttachment;
